<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<a id="title1"><h1 class="title">ACKNOWLEDGMENTS</h1>
<p class="p"><span>I wish to express my wholehearted thanks to Erin Vosgien, the editor of all three of my Arcadia books. Always there with ready encouragement and advice, she has greatly facilitated the transition from idea to the printed page.</span></p>
<p class="p-indent"><span>To Eileen Wolfberg, I offer my sincere gratitude for reviewing my text and for her insightful comments and corrections.</span></p>
<p class="p-indent"><span>I am most thankful to Clarence Wolf, who has again demonstrated his flair for things historic and for his knowledge of Philadelphia’s neighborhoods.</span></p>
<p class="p-indent"><span>Most of all, I am extremely lucky to have Karen Spector as my wife and best friend. Although not involved in the writing aspect of my books, she has been my ultimate supporter and local public relations person.</span></p></a></div><a id="title1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439636183_ack01.vue?0d64b04d